import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { PageContainer } from "../../components/PageContainer";
import { Tabs } from "../../components/Tabs/Tabs";
import { useTabFromQuery } from "../../hooks/useTabFromQuery";
import { getMayorModules } from "../../selectors/mayorModules";
import { MayorModuleStatus, MayorModulesType } from "../../types/mayorModules";
import { BannersComponent } from "./BannersComponent";
import { CollectionPointBilling } from "./CollectionPointBilling";
import { CollectionPointPageHeaderComponent } from "./CollectionPointPageHeaderComponent";
import { CollectionPointTable } from "./CollectionPointTable";
import { CollectionYardsVisitsDetailTable } from "./CollectionYardsVisitsDetailTable";

import styles from "./CollectionPointPage.module.scss";

export enum CollectionPointPageTab {
  WasteContainers = "wasteContainers",
  CollectionYardVisits = "collectionYardVisits",
}

export const CollectionPointPage: React.FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<string>(CollectionPointPageTab.WasteContainers);
  const modules = useSelector(getMayorModules);
  useTabFromQuery(setSelectedTab);

  const TABS = useMemo(() => {
    const tabs = [
      {
        value: CollectionPointPageTab.WasteContainers,
        label: t(CollectionPointPageTab.WasteContainers),
        component: (
          <>
            <CollectionPointBilling />
            <CollectionPointTable />,
          </>
        ),
      },
    ];

    if (modules[MayorModulesType.CollectionYardsModule] === MayorModuleStatus.active) {
      tabs.push({
        value: CollectionPointPageTab.CollectionYardVisits,
        label: t(CollectionPointPageTab.CollectionYardVisits),
        component: <CollectionYardsVisitsDetailTable />,
      });
    }

    return tabs;
  }, [modules, t]);

  return (
    <PageContainer
      HeaderComponent={CollectionPointPageHeaderComponent}
      module={MayorModulesType.CollectionPointModule}
      fullScreen={false}
    >
      <div className={styles.content}>
        <BannersComponent />
        <div className={styles.tabsContainer}>
          <Tabs tabs={TABS} selectedTab={selectedTab} onTabChange={setSelectedTab} />
        </div>
      </div>
    </PageContainer>
  );
};
